import { css, styled } from 'styled-components';
import { Box } from '@design-system/box';
export const Container = styled(Box) `
  display: flex;
  padding: ${({ theme }) => theme.space[1]}px;
  gap: ${({ theme }) => theme.space[3]}px;
  background: ${({ theme }) => theme.colors.floralWhite};
  border-radius: ${({ theme }) => theme.space[2]}px;
`;
export const Control = styled(Box).withConfig({
    shouldForwardProp: (prop) => prop !== 'active',
}) `
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  justify-content: center;
  padding: ${({ size, theme }) => `${size === 'small' ? theme.space[2] : theme.space[3]}px ${theme.space[2]}px`};

  font-size: ${({ size, theme }) => size === 'small' ? theme.fontSizes[1] : theme.fontSizes[2]};
  line-height: ${({ size, theme }) => size === 'small' ? theme.lineHeights[1] : theme.lineHeights[3]};
  text-align: center;
  color: ${({ theme }) => theme.colors.asphalt};
  border-radius: ${({ theme }) => theme.space[2]}px;

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease-in-out;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  ${({ active, theme }) => active &&
    css `
      background: ${theme.colors.white};
      color: ${theme.colors.primary};
      font-weight: ${theme.fontWeights[1]};
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
    `}

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    font-weight: ${({ theme }) => theme.fontWeights[1]};
  }
`;
export const Text = styled.span `
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: inherit;
  color: inherit;
  transition: all 0.2s ease-in-out;
`;
//# sourceMappingURL=index.js.map